<template>
  <el-button type="primary" icon="el-icon-download" @click="Out" v-loading.fullscreen.lock="fullscreenLoading">{{buttonname}}</el-button>
</template>

<script>
export default {
  name: 'ExportButton',
  data () {
    return {
      fullscreenLoading: false
    }
  },
  props: {
    url: {
      type: String
    },
    buttonname: {
      type: String,
      default: '导出'
    }
  },
  methods: {
    Out: function () {
      var parent = this.$parent
      var levelCount = this.level == null ? 0 : this.level
      for (var i = 2; i <= levelCount; i++) {
        parent = parent.$parent
      }
      console.log(parent.condition)
      if (parent.ListOut != null) {
        parent.ListOut()
      } else {
        this.fullscreenLoading = true
        this.$http.post(this.url, parent.condition)
          .then(res => {
            console.log(res)
            if (res.data.Code === 0) {
              var filename = res.data.Data
              var url = this.$utils.Url.zpgl + '/doc/' + filename
              window.open(url)
            }
            this.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '导出失败',
              type: 'error'
            })
            this.fullscreenLoading = false
          })
      }
    }
  }
}
</script>

<style>
</style>
